import { lazy } from 'react';
import { registerWidget } from '..';

registerWidget(
  'PolicyPickerWidget',
  lazy(
    () =>
      import(
        '../../pages/claimForms/widgets/PolicyPickerWidget/PolicyPickerWidget'
      )
  )
);

registerWidget(
  'RedirectToFollowUpWidget',
  lazy(() => import('../../pages/trackMyCase/widgets/RedirectToFollowUpWidget'))
);

registerWidget(
  'ExpensesWidget',
  lazy(() => import('../../pages/trackMyCase/follow-up/ExpensesWidget'))
);

registerWidget(
  'DocumentationWidget',
  lazy(() => import('../../pages/trackMyCase/follow-up/DocumentationWidget'))
);

registerWidget(
  'AttachmentsWidget',
  lazy(() => import('../../pages/trackMyCase/follow-up/AttachmentsWidget'))
);

registerWidget(
  'ExtraDocumentationWidget',
  lazy(() => import('../../pages/trackMyCase/widgets/ExtraDocumentationWidget'))
);

registerWidget(
  'ProcessingMessageWidget',
  lazy(() => import('../../pages/trackMyCase/widgets/processingMessageWidget'))
);

registerWidget(
  'PossessionsWidget',
  lazy(() => import('../../pages/trackMyCase/follow-up/PossessionsWidget'))
);

registerWidget(
  'ProductTypeSelectWidget',
  lazy(
    () => import('../../pages/trackMyCase/follow-up/ProductTypeSelectWidget')
  )
);

registerWidget(
  'ProductSearchInputWidget',
  lazy(
    () => import('../../pages/trackMyCase/follow-up/ProductSearchInputWidget')
  )
);

registerWidget(
  'CarDamageWidget',
  lazy(
    () =>
      import('../../pages/claimForms/claimFormsPrivate/vehicle/CarDamageWidget')
  )
);

registerWidget(
  'WorkshopBookingWidget',
  lazy(() => import('../../pages/trackMyCase/widgets/WorkshopBookingWidget'))
);

registerWidget(
  'MapLocatorWidget',
  lazy(
    () =>
      import(
        '../../pages/claimForms/claimFormsPrivate/vehicle/MapLocatorWidget'
      )
  )
);

registerWidget(
  'LoginAsOtherUserWidget',
  lazy(() => import('../../pages/claimForms/widgets/LoginAsOtherUserWidget'))
);

registerWidget(
  'CounterpartLicensePlateNumbersWidget',
  lazy(
    () =>
      import(
        '../../pages/claimForms/claimFormsPrivate/vehicle/CounterpartLicensePlateNumbersWidget'
      )
  )
);

registerWidget(
  'OrganizationNumberWidget',
  lazy(
    () =>
      import(
        '../../pages/claimForms/claimFormsCorporate/widgets/OrganizationNumberWidget'
      )
  )
);

registerWidget(
  'ActivePolicyWidget',
  lazy(
    () =>
      import(
        '../../pages/claimForms/claimFormsCorporate/widgets/ActivePolicyWidget'
      )
  )
);

registerWidget(
  'MultipleItemsWidget',
  lazy(
    () =>
      import(
        '../../pages/claimForms/claimFormsCorporate/building/MultipleItemsWidget'
      )
  )
);

registerWidget(
  'PostalCodeWidget',
  lazy(() => import('../../pages/claimForms/widgets/PostalCodeWidget'))
);

registerWidget(
  'AnsweredEventWidget',
  lazy(() => import('../../pages/trackMyCase/widgets/AnsweredEventWidget'))
);

registerWidget(
  'PolicyOrRegistrationNumberWidget',
  lazy(
    () =>
      import(
        '../../pages/claimForms/claimFormsCorporate/widgets/PolicyOrRegistrationNumberWidget'
      )
  )
);

registerWidget(
  'StrippedWhitespaceWidget',
  lazy(
    () =>
      import(
        '../../pages/claimForms/claimFormsCorporate/widgets/StrippedWhitespaceWidget'
      )
  )
);
